import { FC } from 'react';

import Skeleton from 'react-loading-skeleton';

import { IMerchant, IMerchantResponse, useMerchants } from '@entities/merchant';
import ErrorMessage from '@shared/components/ErrorMessage';
import { SelectAsync } from '@shared/components/Form';

import 'react-loading-skeleton/dist/skeleton.css';

interface IProps {
  name?: string;
  email?: string;
  domain?: string;
  selectedMerchant?: string;
  onChangeMerchant?: (merchantId: string) => void;
}

export const MerchantsSelectAsync: FC<IProps> = ({
  name = '',
  email = '',
  domain = '',
  selectedMerchant,
  onChangeMerchant,
}) => {
  const { merchants, filter, isLoading, isFetching, error } = useMerchants({
    name,
    email,
    domain,

    disableUrlFilter: true,
  });

  if (isLoading) return <Skeleton height={42} />;
  if (error) {
    return (
      <>
        <select></select>
        <ErrorMessage error={error} />
      </>
    );
  }

  if (merchants) {
    const selectedValueProp = selectedMerchant ? { selectedValue: selectedMerchant } : {};
    return (
      <SelectAsync<IMerchant, IMerchantResponse>
        name={name}
        data={merchants}
        getOptionValue={merchant => merchant.id}
        getOptionLabel={merchant => merchant.short_name}
        filter={filter}
        filterKey='short_name'
        selectedValue={selectedMerchant}
        onChange={onChangeMerchant}
        {...selectedValueProp}
        isLoading={isLoading || isFetching}
        error={error}
      />
    );
  }

  return null;
};
